(function () {
  function slideWidth(viewport) {
    var slide = viewport.querySelector('.mm-ps__slide');
    if (!slide) return viewport.clientWidth;
    var track = viewport.querySelector('.mm-ps__track');
    var styles = window.getComputedStyle(track || viewport);
    var gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
    return slide.getBoundingClientRect().width + gap;
  }

  function bindSlider(root) {
    var viewport = root.querySelector('[data-mm-track]');
    if (!viewport || root.dataset.mmBound) return;
    root.dataset.mmBound = 'true';

    var prev = root.querySelector('[data-mm-prev]');
    var next = root.querySelector('[data-mm-next]');

    function go(dir) {
      viewport.scrollBy({ left: dir * slideWidth(viewport), behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    var startX = 0;
    var startLeft = 0;
    var dragging = false;
    var didDrag = false;
    var THRESHOLD = 8;

    viewport.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (e.target.closest('a, button, input, label, select, textarea')) return;
      dragging = true;
      didDrag = false;
      startX = e.clientX;
      startLeft = viewport.scrollLeft;
    });

    viewport.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (!didDrag && Math.abs(dx) < THRESHOLD) return;
      didDrag = true;
      viewport.scrollLeft = startLeft - dx;
    });

    function endDrag() {
      dragging = false;
    }

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    viewport.addEventListener('pointerleave', endDrag);

    viewport.addEventListener('click', function (e) {
      if (!didDrag) return;
      e.preventDefault();
      e.stopPropagation();
      didDrag = false;
    }, true);
  }

  function init() {
    document.querySelectorAll('.mm-ps').forEach(bindSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
